import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'big-service-tools-diagnosis-code-search-item-list',
    templateUrl: './diagnosis-code-search-item-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'flex flex-wrap max-w-full',
    },
})
export class DiagnosisCodeSearchItemListComponent {
    public readonly items = input.required<string[]>();
}
